import React, { Component } from 'react'

var islands = [
	{name: "Motutapu", desc: "This predator free island is undergoing extensive conservation work and is home to growing colonies of Oyster Catchers, Kiwi, Shore Plover and Takahe among others.", imageSrc: "motutapu.jpg"},
	{name: "Tiritiri Matangi", desc: "Tiritiri Matangi Island is a wildlife sanctuary and one of New Zealand's most important and exciting conservation projects. It is located 30km north east of central Auckland. Over a hundred years of farming had seen this 220-hectare island stripped of 94% of its native bush but between 1984 and 1994, volunteers planted between 250,000 and 300,000 trees. The Island is now 60% forested with the remaining 40% left as grassland for species preferring open habitat.", imageSrc: "tiritiri.jpg"},
	{name: "Little Barrier Island (Hauturu)", desc: "Hauturu's 3,083-hectare landmass makes it one of New Zealand's largest offshore island reserves. It is home to a greater number of endangered birds than any other island in the country and is also home to over 400 species of native plants. Bryde's whales, Orcas and Bottlenose dolphins live in the waters around the island. Blue whale and Southern right whales rest in this area during migration.", imageSrc: "little-barrier-island.jpg"}
]

class IslandSlider extends Component {

	constructor(props){
		super(props);
		this.state = {
			sliderIndex: 0
		}
		this.IncrementIslandSlider = this.IncrementIslandSlider.bind(this)
	}

	componentDidMount(){this.interval = setInterval(() => {this.IncrementIslandSlider()}, 10000)}

	componentWillUnmount(){clearInterval(this.interval)}
	
	IncrementIslandSlider(){
		var sliderIndex = this.state.sliderIndex, newSliderIndex;
		if (islands){if(sliderIndex === islands.length - 1){newSliderIndex = 0} else {newSliderIndex = sliderIndex + 1}} else {newSliderIndex = 0;}
		this.setState({sliderIndex: newSliderIndex})
	}

	render(){
		var {sliderIndex} = this.state, {awsPrefix} = this.props;
		return(
			<div className={`FlexContainer RowToColumn SpaceLeftX8-DT SpaceRightX8-DT SpaceAboveX8 Width80-MB`}>
				<div className={`FlexContainer Flex Column FlexStart`}>
					<p className={`TextCentre-MB`}>______</p>

					<h2 className={`SpaceAboveX2 TextCentre-MB`}>{islands[sliderIndex].name}</h2>

					<p className={`LightText SpaceAboveX2 SpaceRightX8-DT`}>{islands[sliderIndex].desc}</p>
				</div>
				<div className={`FlexContainer Flex SpaceAboveX2-MB`}>
					<img src={`${awsPrefix}islands/${islands[sliderIndex].imageSrc}`} alt={islands[sliderIndex].name} className={`SpaceRightX4-DT SpaceLeftX8-DT FullWidth`} />
				</div>
			</div>
		)
	}
}

export default IslandSlider